import { usePageTitle } from '@/hooks/use-page-title';
import { useVoiceCopy } from '@/platform/voice/use-voice';
import { KiMark } from '@/components/ki-mark';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { IntranetAsk } from '@/products/intranet/components/intranet-ask';

export function IntranetAiPage() {
  const copy = useVoiceCopy();
  usePageTitle('Intranet fragen');

  return (
    <section className="space-y-6">
      <PlatformPageHeader
        title={
          <span className="inline-flex items-center gap-2">
            <KiMark className="size-7 text-primary" />
            Intranet fragen
          </span>
        }
        description={copy('intranet.ai.page-description')}
      />
      <IntranetAsk variant="page" />
    </section>
  );
}
